/* -------------------------------------------------------------------------- *
 * Unit Preference (Metric/Imperial) *
 * -------------------------------------------------------------------------- *
 * Saves the user's unit preference as a cookie.
 */

const settings = {
    selector: '.js-units',
};

const targetEl = document.getElementById('specificationsTab');

function setCookie(name, value = '', days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

    // Set the cookie
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function updatePreference() {
    // Set the cookie
    const preference = this.value;
    setCookie('units', preference);

    // Reload the page
    if (targetEl) {
        window.location.hash = '#specifications';
    }
    window.location.reload(true);
    return false;
}

function specificationInit() {
    if (window.location.hash === '#specifications') {
        document.getElementById('overviewTab').classList.remove('is-active');
        document.getElementById('specificationsTab').classList.add('is-active');
        document.getElementById('js-overview').setAttribute('hidden', true);
        document.getElementById('js-overview').classList.remove('is-active');
        document.getElementById('form').style.display = 'none';
        window.addEventListener('load', () => {
            document.getElementById('specificationsTab').click();
            document.getElementById('form').style.display = 'block';
        }, false);
    }
}

/* ------------- *
 * Module Export *
 * ------------- */

const Units = {
    selector: settings.selector,

    init(selector = settings.selector) {
        const inputs = document.querySelectorAll(selector);
        const input_arr = Array.from(inputs);

        input_arr.forEach((input) => {
            input.addEventListener('change', updatePreference);
        });

        specificationInit();
    },
};

export default Units;
